import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
// import UsersListLayer from "../components/UsersListLayer";
import AboutUsPageLayer from "../components/AboutUsPageLayer";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="About us" header="Our Facilitators" />

        {/* UsersListLayer */}
        <AboutUsPageLayer />

      </MasterLayout>

    </>
  );
};

export default UsersListPage; 
